import React from "react";
import "./footer.scss";
const Footer = ({ ref }) => {
  return (
    <div className="footer_main" ref={ref}>
      <div className="footer_container">
        <div className="footer_links">
          <a>HOME</a>
          <a>PROJECTS</a>
          <a>CONTACT</a>
        </div>
        <div className="footer_rights">
          <p>
            © {new Date().getFullYear()} RenderX Architects. All rights
            reserved. | <a>Privacy Policy</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
